import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';
import FsButton from 'ui-elements/buttons/FsButton';
import { FsButtonProps } from 'ui-elements/buttons/FsButton/FsButton';

export const WrapperBox = withStyles(({ spacing }: Theme) => ({
  root: {
    margin: spacing(0, 'auto'),
    textAlign: 'center',
    maxWidth: 383,
  },
}))(Box);

export const Button = withStyles(({ spacing }: Theme) => ({
  root: {
    marginBottom: spacing(2),
    textAlign: 'center',
  },
}))((props: FsButtonProps) => (
  <FsButton {...props} color="primary" variant="contained" />
));
